import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import MoreVert from "@material-ui/icons/MoreVert";
import axios from "axios";
import { ITopElement } from "backend/model/model";
import { t } from "i18next";
import { getKpisAndProjectsManagementHierarchyMode } from "qpr-base/configuration";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { getElementName } from "qpr-base/tplutils/utils";
import Loader from "qpr-base/ui/components/Loader";
import DeleteModal from "qpr-base/uicomponents/view/DeleteModal";
import React, { FunctionComponent } from "react";
import MetadataView from "./MetadataView";
import { MappedData } from "./index.dto";
import { useStylesViewTable as useStyles } from "./stylesKpiProjectManagement";

function MoreBtn({
  id,
  ctx,
  linkHandler,
  isKpi,
  metaData,
  configsData,
  isAdmin,
  showDeleteModal,
  setDeletedId,
  userRole,
  selectedLevel,
}: {
  id: string;
  linkHandler: (type: string) => void;
  isKpi?: boolean;
  metaData?: any;
  ctx: any;
  isAdmin: boolean;
  showDeleteModal: (val: boolean) => void;
  setDeletedId: (id: string) => void;
  configsData: {
    create: boolean;
    edit: boolean;
    delete: boolean;
  };
  userRole: string;
  selectedLevel: string;
}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [metaDataModal, setMetaDataModal] = React.useState<boolean>(false);

  function onMoreClicked(event: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  const onEdit = (meaId: string) => {
    linkHandler(`${isKpi ? "kpi" : "project"}sform/?id=${meaId}&type=existing`);
    setAnchorEl(null);
  };

  async function onDelete() {}

  function onClose() {
    setAnchorEl(null);
  }
  if (metaDataModal) {
    return (
      <MetadataView
        metaData={metaData}
        open={metaDataModal}
        meaId={id}
        rtl={ctx.rtl}
        setOpen={setMetaDataModal}
        onEdit={onEdit}
        disableEdit={!(isAdmin || configsData.edit)}
      />
    );
  }
  return (
    <>
      <Menu
        className={classes.simpleMenu}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => onClose()}
        dir={ctx.rtl ? "rtl" : "ltr"}
      >
        <MenuItem
          onClick={() => onEdit(id)}
          disabled={!(isAdmin || configsData.edit)}
        >
          <EditOutlinedIcon /> <span>{t("edit")}</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setDeletedId(id);
            showDeleteModal(true);
            setAnchorEl(null);
          }}
          disabled={!(isAdmin || configsData.delete)}
        >
          <DeleteOutlineOutlinedIcon /> <span>{t("delete")}</span>
        </MenuItem>
      </Menu>

      <div
        className={classes.moreBtn}
        onClick={(ev: any) => onMoreClicked(ev)}
        onKeyDown={(ev: any) => onMoreClicked(ev)}
        role="button"
        tabIndex={0}
      >
        <MoreVert
          style={{
            // height: '100%',
            width: "100%",
          }}
        />
      </div>
    </>
  );
}

interface ViewTableProps {
  headers: Array<string>;
  metaDatas: any[];
  elements: MappedData[] | undefined;
  topElements: ITopElement[];
  elementDeleted: (id: string) => void;
  linkeHandler: (type: string) => void;
  isAdmin: boolean;
  configsData: {
    create: boolean;
    edit: boolean;
    delete: boolean;
  };
  isKpi?: boolean;
  userRole: string;
  selectedLevel: string;
}

const ViewTable: FunctionComponent<ViewTableProps> = (
  props: ViewTableProps
) => {
  const classes = useStyles();
  const ctx = useAppContext();

  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [deletedId, setDeletedId] = React.useState("");
  const [processing, setProcessing] = React.useState(false);

  const deleteElement = async () => {
    setOpenDeleteModal(false);
    setProcessing(true);

    const res = await axios
      .post(props.isAdmin ? "workflow/directupdate" : "workflow/instances", {
        meaId: deletedId,
        ...(props.isAdmin
          ? {
              type: "delete",
            }
          : {
              type: "delete",
              elementType: props.isKpi ? "KPI" : "Initiative",
              series: "",
              period: "",
            }),
      })
      .then((result) => {
        return result;
      })
      .catch((err) => err);
    if (res.status === 201 || res.status === 200) {
      alert(
        t(
          props.isAdmin
            ? "Element deleted"
            : "Element deletion sent for approval"
        )
      );
      if (props.isAdmin) props.elementDeleted(deletedId);
    } else {
      alert(
        res.response.data?.message?.includes("already exists")
          ? t(
              `Deletion workflow for this ${
                props.isKpi ? "kpi" : "project"
              } already exists!`
            )
          : t(
              `Something went wrong with ${
                props.isKpi ? "kpi" : "project"
              } deletion`
            )
      );
    }
    setProcessing(false);
  };

  const hierarchyMode = getKpisAndProjectsManagementHierarchyMode();

  return (
    <>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {props.headers.map((h) => (
                <TableCell
                  style={{ fontSize: "16px", color: "#9EA5AD" }}
                  align={ctx.rtl ? "right" : "left"}
                >
                  {h}
                </TableCell>
              ))}
              <TableCell align="center" />
            </TableRow>
          </TableHead>
          <TableBody>
            {(props.elements || []).map((element, idx) => (
              <TableRow key={`${idx}`}>
                <TableCell
                  style={{
                    fontSize: "16px",
                    color: "#4C5157",
                    fontWeight: "500",
                  }}
                  align={ctx.rtl ? "right" : "left"}
                >
                  {getElementName(
                    { ...element, ...{ JS_ATTR: element.translations } },
                    ctx.language
                  )}
                </TableCell>

                {hierarchyMode === "Perspectives" ? (
                  <TableCell
                    style={{
                      fontSize: "16px",
                      color: "#4C5157",
                      fontWeight: "500",
                    }}
                    align={ctx.rtl ? "right" : "left"}
                  >
                    {getElementName(
                      props.topElements.find(
                        (el: ITopElement) => el.id === element.topelementid
                      ),
                      ctx.language
                    )}
                  </TableCell>
                ) : (
                  <></>
                )}

                <TableCell align="center">
                  <MoreBtn
                    id={element.id}
                    linkHandler={props.linkeHandler}
                    configsData={props.configsData}
                    isAdmin={props.isAdmin}
                    isKpi={props.isKpi}
                    // metaData={JSON.parse(props.metaDatas[idx]) || ""}
                    metaData={""}
                    userRole={props.userRole}
                    showDeleteModal={setOpenDeleteModal}
                    setDeletedId={setDeletedId}
                    selectedLevel={props.selectedLevel}
                    ctx={ctx}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <DeleteModal
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        handleDelete={() => deleteElement()}
        title={t(props.isKpi ? "Delete KPI" : "Delete Project")}
        subTitle={t(
          props.isAdmin
            ? "Are you sure you want to delete this element"
            : "Start workflow to delete this element?"
        )}
        cancelButtonCaption={props.isAdmin ? undefined : "Cancel"}
        okButtonCaption={props.isAdmin ? undefined : "Start workflow"}
      />
      {processing && <Loader />}
    </>
  );
};

export default ViewTable;
